module.exports = __webpack_public_path__ + "img/adecco-option.bc9b3cac.svg";